enum sortTypes {
  DEFAULT = 'default',
  NAME = 'name',
  GENDER = 'gender',
  PLACE = 'place',
}

export default sortTypes;
